import React from 'react'
import ArticlePosts from '../components/ArticlePosts'

const Article = () => {
  return (
    <ArticlePosts/>
  )
}

export default Article